import React from 'react'
import { Typography } from '@material-ui/core'
import { t } from 'ttag'

// Import custom components
import YumDrawer from '../../../../components/YumDrawer/YumDrawer'
import YumCancelButton from '../../../../components/YumCancelButton/YumCancelButton'
import YumSubmitButton from '../../../../components/YumSubmitButton/YumSubmitButton'
import YumButtonGroup from '../../../../components/YumButtonGroup/YumButtonGroup'

interface DiscardConfirmationModalProps {
  /** Whether the modal is open */
  open: boolean
  /** Callback when the modal should be closed */
  onClose: () => void
  /** Callback when discard is confirmed */
  onConfirm: () => void
}

/**
 * Confirmation modal for discarding workouts
 * Shows a confirmation dialog with "Cancel" and "Confirm" buttons
 */
export const DiscardConfirmationModal: React.FC<DiscardConfirmationModalProps> = ({ open, onClose, onConfirm }) => {
  // Handle confirm action
  const handleConfirm = () => {
    onConfirm()
    onClose()
  }

  return (
    <YumDrawer
      disableSwipeToClose={true}
      open={open}
      onClose={onClose}
      onOpen={() => {}}
      PaperProps={{
        style: {
          background: 'white',
          borderTopLeftRadius: '30px',
          borderTopRightRadius: '30px',
          paddingTop: '20px',
          paddingRight: '20px',
          paddingLeft: '20px',
        },
      }}
    >
      <div
        style={
          {
            /*{ padding: '24px 0' }*/
          }
        }
      >
        {/* Modal Title */}
        <Typography variant="h6" style={{ marginBottom: '20px' }}>{t`Discard activity`}</Typography>

        {/* Modal Content */}
        <Typography variant="body1" style={{ marginBottom: '24px' }}>
          {t`Are you sure you want to discard your activity?`}
        </Typography>

        {/* Action Buttons */}
        <YumButtonGroup>
          <YumCancelButton onClick={onClose} text={t`Cancel`} color="inherit" />
          <YumSubmitButton onClick={handleConfirm} text={t`Confirm`} color="error" />
        </YumButtonGroup>
      </div>
    </YumDrawer>
  )
}

export default DiscardConfirmationModal
